var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCampaign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_12517_486967",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 25
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_12517_486967)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21 13.499H19C18.7167 13.499 18.4792 13.4031 18.2875 13.2115C18.0958 13.0198 18 12.7823 18 12.499C18 12.2156 18.0958 11.9781 18.2875 11.7865C18.4792 11.5948 18.7167 11.499 19 11.499H21C21.2833 11.499 21.5208 11.5948 21.7125 11.7865C21.9042 11.9781 22 12.2156 22 12.499C22 12.7823 21.9042 13.0198 21.7125 13.2115C21.5208 13.4031 21.2833 13.499 21 13.499ZM16.6 17.299C16.7667 17.0656 16.9833 16.9323 17.25 16.899C17.5167 16.8656 17.7667 16.9323 18 17.099L19.6 18.299C19.8333 18.4656 19.9667 18.6823 20 18.949C20.0333 19.2156 19.9667 19.4656 19.8 19.699C19.6333 19.9323 19.4167 20.0656 19.15 20.099C18.8833 20.1323 18.6333 20.0656 18.4 19.899L16.8 18.699C16.5667 18.5323 16.4333 18.3156 16.4 18.049C16.3667 17.7823 16.4333 17.5323 16.6 17.299ZM19.6 6.69896L18 7.89896C17.7667 8.06563 17.5167 8.13229 17.25 8.09896C16.9833 8.06563 16.7667 7.93229 16.6 7.69896C16.4333 7.46563 16.3667 7.21563 16.4 6.94896C16.4333 6.68229 16.5667 6.46563 16.8 6.29896L18.4 5.09896C18.6333 4.93229 18.8833 4.86562 19.15 4.89896C19.4167 4.93229 19.6333 5.06563 19.8 5.29896C19.9667 5.53229 20.0333 5.78229 20 6.04896C19.9667 6.31563 19.8333 6.53229 19.6 6.69896ZM5 15.499H4C3.45 15.499 2.97917 15.3031 2.5875 14.9115C2.19583 14.5198 2 14.049 2 13.499V11.499C2 10.949 2.19583 10.4781 2.5875 10.0865C2.97917 9.69479 3.45 9.49896 4 9.49896H8L11.475 7.39896C11.8083 7.19896 12.1458 7.19896 12.4875 7.39896C12.8292 7.59896 13 7.89063 13 8.27396V16.724C13 17.1073 12.8292 17.399 12.4875 17.599C12.1458 17.799 11.8083 17.799 11.475 17.599L8 15.499H7V18.499C7 18.7823 6.90417 19.0198 6.7125 19.2115C6.52083 19.4031 6.28333 19.499 6 19.499C5.71667 19.499 5.47917 19.4031 5.2875 19.2115C5.09583 19.0198 5 18.7823 5 18.499V15.499ZM11 14.949V10.049L8.55 11.499H4V13.499H8.55L11 14.949ZM14 15.849V9.14896C14.45 9.54896 14.8125 10.0365 15.0875 10.6115C15.3625 11.1865 15.5 11.8156 15.5 12.499C15.5 13.1823 15.3625 13.8115 15.0875 14.3865C14.8125 14.9615 14.45 15.449 14 15.849Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCampaign);
export default __webpack_public_path__ + "static/media/campaign.a1e7582f4c67785674ac0eae309e1197.svg";
export { ForwardRef as ReactComponent };